import React, { useEffect, useState } from 'react'
import s from './pages.module.css'
import { useAppDispatch, useAppSelector } from '../../app/Hooks';
import { pagesNumberReducer } from '../../app/slices/dataSlice';
import { pageReducer } from '../../app/slices/pagesSlice';



const NumberPages = () => {

  const dispatch = useAppDispatch()

  const rowsPerPageOptions: number[] = [20, 40, 60, 80]
  const totalItems: number = useAppSelector(state => state.data.data.total)
  const currentPage = useAppSelector(state => state.pages.pages.currPage)
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);

  // Вычисляем общее количество страниц
  const totalPages = Math.max(1, Math.ceil(totalItems / rowsPerPage));

  useEffect(() => {
    dispatch(
      pagesNumberReducer({
        limit: rowsPerPage,
        offset: rowsPerPage * (currentPage - 1) 
      })
    );
  }, [currentPage, rowsPerPage, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(pageReducer(1))
    }

  }, [dispatch])

  // Обработчик изменения страницы
  const handlePageChange = (page: number) => {
    dispatch(pageReducer(page));
  };

  // Обработчик изменения количества строк на странице
  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setRowsPerPage(Number(event.target.value));
    dispatch(pageReducer(1)); // Сбрасываем на первую страницу при изменении rowsPerPage
  };

  // Генерация номеров страниц с точками
  const generatePageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 4; // Максимальное количество видимых страниц
    let startPage = 1;
    let endPage = totalPages;

    if (totalPages > maxVisiblePages) {
      if (currentPage <= maxVisiblePages - 2) {
        startPage = 1;
        endPage = maxVisiblePages - 1;
      } else if (currentPage >= totalPages - (maxVisiblePages - 2)) {
        startPage = totalPages - (maxVisiblePages - 2);
        endPage = totalPages;
      } else {
        startPage = currentPage - 1;
        endPage = currentPage + 1;
      }
    }

    // Добавляем первую страницу и точки, если нужно
    if (startPage > 1) {
      pages.push(1);
      if (startPage > 2) {
        pages.push('...');
      }
    }

    // Добавляем видимые страницы
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    // Добавляем последнюю страницу и точки, если нужно
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push('...');
      }
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className={s.pagesTotal}>
      {/* Выбор количества строк на странице */}
      <div>
        <label>
          Показать на странице:
          <select value={rowsPerPage} onChange={handleRowsPerPageChange}>
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </label>
      </div>

      {/* Пагинация */}
      <div>
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Предыдущая
        </button>
        {generatePageNumbers().map((page, index) =>
          page === '...' ? (
            <span key={index} style={{ margin: '0 5px' }}>
              ...
            </span>
          ) : (
            <button
              key={index}
              onClick={() => handlePageChange(page as number)}
              style={{
                fontWeight: currentPage === page ? 'bold' : 'normal',
                margin: '0 5px',
              }}
            >
              {page}
            </button>
          )
        )}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Следущая
        </button>
      </div>

      {/* Отображение текущей страницы и строк на странице */}
      <div>
        <p>
          Страница {currentPage} из {totalPages}
        </p>
        {/*<p>
              от {(currentPage - 1) * rowsPerPage + 1} до{' '}
              {Math.min(currentPage * rowsPerPage, totalItems)} из {totalItems} страниц
            </p>*/}
      </div>
    </div>
  );
};


export default NumberPages